import { pipe, Either, Task } from "fp";

import { type, creator, reducer, effects } from "~/Action";

import * as Data from "~/Data";
import * as WorkCode from "~/WorkCode";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Work codes requested" as const),
    reducer(({ state }) => {
      state.workCodes.store = Data.Store.requested(state.workCodes.store);
    }),
    effects(
      ({ dispatch, state: { context, companies, logs } }) =>
        logs.active &&
        pipe(
          WorkCode.Request.Get.request(companies.current.company.id)(context),
          Task.map((workCodes) => dispatch(Received.create(workCodes)))
        )()
    )
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Work codes received" as const),
    creator(
      (workCodes: Either.ErrorOr<Data.Cache.Cache<WorkCode.WorkCode>>) => ({
        workCodes,
      })
    ),
    reducer(
      ({ state, action: { workCodes } }) =>
        (state.workCodes.store = Data.Store.received(workCodes)(
          state.workCodes.store
        ))
    )
  );
}
